import React, { useRef, useState, useEffect } from "react";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import Snackbar from "@mui/material/Snackbar";
import LogoGeosoftsolutions from "../assets/LogoGeosoftsolutions.png";

import { restaurarPassword } from "../service/apiService";
import { useForm , useWatch } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";

function ChangePassword() {

  //react-router-doom
  const navigate = useNavigate();
  const location = useLocation();

  //react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  //inputs password
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [showPassword2, setShowPassword2] = useState(false);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  //snackbar de alertas
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
  });

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get("email");

  //cierra el snackbar
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  //restaura el password
  const onSubmit = async (data) => {
    if(data.password !== data.password_confirmation)
    {
      setSnackbar({ message: "Las contraseñas ingresadas no coinciden", open: true });
      return;
    }

    const response = await restaurarPassword({
      email: email,
      token: token,
      password: data.password,
      password_confirmation: data.password_confirmation
    });

    setSnackbar({ message: response?.message, open: true });

    if(response.result)
    {
      navigate("/login");
    }

    // console.log({ response });
    // console.log({ data });
  };

  //action snackbar
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" className="text-amarillo" />
      </IconButton>
    </React.Fragment>
  );

  useEffect(() => {
    if (!token && !email) 
    {
      navigate("/");
    };
  }, [token, email, navigate]);

  //estilo del input
  const inputStyle = {
    //input
    input: {
      color: "#fffcfc",
      "::placeholder": {
        color: "#fffcfc",
        opacity: 1,
      },
    },
    //label
    label: {
      color: "#fffcfc",
    },
    //focus
    "& label.Mui-focused": {
      color: "#fffcfc",
    },

    //color para los errores
    "& .Mui-error": {
      color: "#cb9636",
    },
    "& label.Mui-error": {
      color: "#cb9636",
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#cb9636",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#cb9636",
    },

    // combate el autofill de los navegadores
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#7b7f89",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#d4d4d8",
      },
      // combate el autofill
      "& input:-webkit-autofill": {
        boxShadow: "0 0 0 1000px #393b40 inset",
        WebkitTextFillColor: "#fffcfc",
        caretColor: "#fffcfc",
        transition: "background-color 5000s ease-in-out 0s",
      },
    },
  };

  //estilo del button
  const styleButton = {
    backgroundColor: "#cb9636",
    color: "#1e1e28",
    "&:hover": {
      backgroundColor: "#fcd488",
    },
    marginTop: "15px",
    display: "block",
    mx: "auto",
    width: "150px",
    height: "32px",
  };

  return (
    <section className="bg-fondo_blanco shadow-xl rounded-lg">
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={snackbar.message}
        action={action}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        ContentProps={{
          sx: {
            color: "#fffcfc",
          },
        }}
      />

      <div className="min-h-[calc(82vh)] flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <div className="w-full rounded-lg shadow-xl md:mt-0 sm:max-w-md xl:p-0 bg-ceniza_light border-gray-700">
          <div className="p-6 space-y-4 md:space-y-4 sm:p-4">
            <img
              className="w-[220px] h-auto mx-auto"
              src={LogoGeosoftsolutions}
              alt="logo"
            />

            <h1 className="text-xl font-bold leading-tight tracking-tight md:text-2xl text-blanco text-center">
              Recuperación de Contraseña
            </h1>

            <form
              className="space-y-4 md:space-y-6"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="rounded-lg block w-full bg-inputs border border-gray-700 shadow-lg p-3 flex">
                <ErrorIcon
                  fontSize="medium"
                  className="text-amarillo mt-5 mr-3"
                />
                <p className="text-blanco text-[12px] text-justify">
                  Por favor, escriba su nueva contraseña. Asegúrese de que sea
                  segura y fácil de recordar. Una vez ingresada, haga clic en
                  'Restablecer' para completar el proceso.
                </p>
              </div>

              <TextField
                required
                type={showPassword ? "text" : "password"}
                id="password"
                label="Contraseña"
                defaultValue=""
                className="rounded-lg block w-full bg-inputs border"
                sx={inputStyle}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon className="text-amarillo" fontSize="10" />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment
                        position="start"
                        onClick={handleClickShowPassword}
                        className="cursor-pointer"
                      >
                        {showPassword ? (
                          <VisibilityOff
                            className="text-amarillo"
                            fontSize="10"
                          />
                        ) : (
                          <Visibility className="text-amarillo" fontSize="10" />
                        )}
                      </InputAdornment>
                    ),
                  },
                }}
                error={!!errors.password}
                helperText={errors.password ? "Campo faltante" : ""}
                {...register("password", { required: true })}
              />

              <TextField
                required
                type={showPassword2 ? "text" : "password"}
                id="password_confirmation"
                label="Confirmar Contraseña"
                defaultValue=""
                className="rounded-lg block w-full bg-inputs border"
                sx={inputStyle}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon className="text-amarillo" fontSize="10" />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment
                        position="start"
                        onClick={handleClickShowPassword2}
                        className="cursor-pointer"
                      >
                        {showPassword2 ? (
                          <VisibilityOff
                            className="text-amarillo"
                            fontSize="10"
                          />
                        ) : (
                          <Visibility className="text-amarillo" fontSize="10" />
                        )}
                      </InputAdornment>
                    ),
                  },
                }}
                error={!!errors.password2}
                helperText={errors.password2 ? "Campo faltante" : ""}
                {...register("password_confirmation", { required: true })}
              />

              <Button
                type="submit"
                role={undefined}
                variant="contained"
                sx={styleButton}
              >
                Restaurar
              </Button>
              
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChangePassword;
